var path = '/components/service-announcement-player/service-announcement-player.component.html';
var html = "<div class=\"drawable\">\n\t<div class=\"headline text-center\">\n\t\t{{data.headline}}\n\t</div>\n\t<div class=\"body text-center\">\n\t\t{{data.body}}\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;